import { GlobalHeader } from 'Shared/global-header';

onDomReady(() => {
   Header.initialize();

   let expandedNavTrigger = '#menu-button';

   if (!$('searchDropdown')) {
      expandedNavTrigger += ', .search-toggle';
   }

   $$(expandedNavTrigger).addEvent('click', ev => {
      ev.stop();
      $$('.mobile-nav').toggleClass('expanded');
   });
});

// eslint-disable-next-line no-var
export var Header = (window.Header = new GlobalHeader());

Header.initialize = function () {
   this.profileMenuToggle = $('profileMenuToggle');
   this.profileMenuContainer = $('profileMenuContainer');
   this.profileMenu = $('profileMenu');

   this.initLanguageModal();

   when(this.profileMenuToggle, () => {
      this.setupHeaderDropdown(this.profileMenuToggle, this.profileMenuContainer);
   });

   window.addEvent('click', ev => {
      if (
         this.searchDropdown &&
         this.searchDropdown.isVisible() &&
         ev.page.y >= this.searchDropdown.getCoordinates().bottom
      ) {
         this.hideSearchDropdown();
      }
   });

   this.searchDropdown = $('searchDropdown');
   if (this.searchDropdown) {
      this.searchDropdown.store('visible', false);
      $$('.search-toggle').addEvent('click', ev => {
         ev.stop();
         if (this.searchDropdown.retrieve('visible')) {
            this.hideSearchDropdown();
         } else {
            this.showSearchDropdown();
         }
      });
   }
};

Header.initLanguageModal = function () {
   $$('.js-trigger-language-modal').addEvent('click', ev => {
      ev.stop();

      let options = {
         type: 'element',
         href: '#language-modal',
      };

      import('Shared/modal').then(({ Modal }) => Modal.open(options));
   });
};

Header.showSearchDropdown = function () {
   this.searchDropdown.removeClass('search-hidden');
   this.searchDropdown.store('visible', true);
   $('mobileSearchForm').focus();
};

Header.hideSearchDropdown = function () {
   this.searchDropdown.addClass('search-hidden');
   this.searchDropdown.store('visible', false);
   $('mobileSearchForm').blur();
};
